import { CardFormControl } from "~/components/ui/core/CardFormControl";

// This component has been promoted as core component
export const ConfigurationFormControl = CardFormControl;
